const currencyRate = [
    {
        id: 1,
        currencyName: "European Union",
        usd: "1.064427",
        type: "Euro (€)",
        exchangeRate: "0.00136"

    },
    {
        id: 2,
        currencyName: "Renminbi (Yuan)",
        usd: "0.14",
        type: "Yuan (¥)",
        exchangeRate: "0.00011"

    },
    {
        id: 3,
        currencyName: "Afghan Afghani",
        usd: "0.011",
        type: "AFN (؋)",
        exchangeRate: "0.00012"

    },
    {
        id: 4,
        currencyName: "Canadian Dollar",
        usd: "0.735505",
        type: "CAD ($)",
        exchangeRate: "0.00214"

    },
    {
        id: 5,
        currencyName: "Danish Kroner",
        usd: "0.14",
        type: "DKK (Kr)",
        exchangeRate: "0.0026"

    },
    {
        id: 6,
        currencyName: "Egyptian Pound",
        usd: "0.040",
        type: "EGP (E£)",
        exchangeRate: "0.00054"

    },
    {
        id: 7,
        currencyName: "Kenyan Shilling",
        usd: "0.0081",
        type: "KES (K)",
        exchangeRate: "0.0000321"

    },
    {
        id: 8,
        currencyName: "United Kingdom",
        usd: "1.20",
        type: "GBP (£)",
        exchangeRate: "0.0374"

    },
    {
        id: 9,
        currencyName: "European Union",
        usd: "1.064427",
        type: "Euro (€)",
        exchangeRate: "0.00136"

    },
    {
        id: 10,
        currencyName: "Colombian Peso",
        usd: "1542.32",
        type: "COP ($)",
        exchangeRate: "0.00524355"

    },
    {
        id: 11,
        currencyName: "Kenyan Shilling",
        usd: "0.0081",
        type: "KES (K)",
        exchangeRate: "0.0000321"

    }
]

const transaction = [
    {
        id: 1,
        type: "down",
        transactionID: "#TBSC320002830",
        amount: "$253.32",
        paymentMethod: "American Express",
        transactionDate: "15 Jan, 2023",
        status: "Successful",
        clientName: "Diana Nichols",
        cleintEmail: "diana@toner.com",
        vatId: "TB211145424"
    },
    {
        id: 2,
        type: "up",
        transactionID: "#TBSC320002836",
        amount: "$745.00",
        paymentMethod: "PayPal",
        transactionDate: "19 Jan, 2023",
        status: "Denied",
        clientName: "Valentine Morin",
        cleintEmail: "euismod.enim@outlook.net",
        vatId: "TB211145425"
    },
    {
        id: 3,
        type: "down",
        transactionID: "#TBSC320002645",
        amount: "$2,145.87",
        paymentMethod: "Discover",
        transactionDate: "01 Nov, 2022",
        status: "Successful",
        clientName: "Brody Holman",
        cleintEmail: "metus@protonmail.org",
        vatId: "TB211155424"
    },

    {
        id: 4,
        type: "up",
        transactionID: "#TBSC320002930",
        amount: "$985.00",
        paymentMethod: "PayPal",
        transactionDate: "20 Jan, 2023",
        status: "Pending",
        clientName: "Jolie Hood",
        cleintEmail: "nunc.nulla@yahoo.edu",
        vatId: "TB211145524"
    }, {
        id: 5,
        type: "up",
        transactionID: "#TBSC320002987",
        amount: "$3654.32",
        paymentMethod: "American Express",
        transactionDate: "29 Feb, 2023",
        status: "Successful",
        clientName: "Buckminster Wong",
        cleintEmail: "dictum.phasellus.in@hotmail.org",
        vatId: "TB211545424"
    },
    {
        id: 6,
        type: "down",
        transactionID: "#TBSC320003001",
        amount: "$654.02",
        paymentMethod: "Visa Credit/Debit",
        transactionDate: "24 Mar, 2023",
        status: "Denied",
        clientName: "Howard Lyons",
        cleintEmail: "neque.sed.dictum@icloud.org",
        vatId: "TB251145424"
    },
    {
        id: 7,
        type: "down",
        transactionID: "#TBSC320003203",
        amount: "$745.02",
        paymentMethod: "Discover",
        transactionDate: "07 Jan, 2023",
        status: "Pending",
        clientName: "Howard Oneal",
        cleintEmail: "porttitor.tellus.non@yahoo.net",
        vatId: "TB211146424"
    },
    {
        id: 8,
        type: "down",
        transactionID: "#TBSC320002830",
        amount: "$3654.19",
        paymentMethod: "American Express",
        transactionDate: "09 May, 2022",
        status: "Denied",
        clientName: "Jena Hall",
        cleintEmail: "lectus.sit.amet@protonmail.edu",
        vatId: "TB211165424"
    },

    {
        id: 9,
        type: "up",
        transactionID: "#TBSC320003319",
        amount: "$874.31",
        paymentMethod: "American Express",
        transactionDate: "17 Sep, 2022",
        status: "Successful",
        clientName: "Paki Edwards",
        cleintEmail: "edwards.phasellus.in@hotmail.org",
        vatId: "TB211145467"
    },
    {
        id: 10,
        type: "up",
        transactionID: "#TBSC320003369",
        amount: "$261.00",
        paymentMethod: "PayPal",
        transactionDate: "15 Jan, 2023",
        status: "Successful",
        clientName: "Nell Potter",
        cleintEmail: "nella@toner.com",
        vatId: "TB211145123"
    },
    {
        id: 11,
        type: "down",
        transactionID: "#TBSC320003203",
        amount: "$745.02",
        paymentMethod: "Discover",
        transactionDate: "07 Jan, 2023",
        status: "Pending",
        clientName: "Howard Oneal",
        cleintEmail: "porttitor.tellus.non@yahoo.net",
        vatId: "TB211146424"
    }
]

export { currencyRate, transaction }